import React from 'react';
import _ from 'lodash';
import { useTheme, Skeleton } from '@mui/material';

import Erisk from '../../../../_assets/svg/Erisk.svg';
import { useActor } from '../../../../components/hooks/useActor';
import { SolidButton } from './styles';
import { RailPromoCard } from './RailPromoCard';

const DESCRIPTION =
  'Go-to resource for all things cyber, shore up defenses and respond to cyber events';

export const ERiskCard = ({ eKey }: any) => {
  const theme = useTheme();
  const actor = useActor();

  const { firstName, lastName, account, id, email } = actor;

  if (_.isUndefined(email) || _.isUndefined(eKey)) {
    return (
      <RailPromoCard
        title="eRiskHub"
        description={<Skeleton variant="text" width="80%" />}
        action={<Skeleton variant="rounded" width="40%" height={36} />}
      />
    );
  }

  return (
    <RailPromoCard
      title="eRiskHub"
      icon={<Erisk fill={theme.palette.primary.contrastText} />}
      description={DESCRIPTION}
      action={
        <form
          action="https://eriskhub.com/cowbell-sso.php"
          method="post"
          name="eRHSSO"
          target="_blank"
        >
          <input name="REQUESTER" type="hidden" value={eKey} />
          <input name="EMAIL" type="hidden" value={email} />
          <input name="USERID" type="hidden" value={id} />
          <input name="FNAME" type="hidden" value={firstName} />
          <input name="LNAME" type="hidden" value={lastName} />
          <input name="ORGANIZATION" type="hidden" value={account?.name} />
          <SolidButton
            type="submit"
            sx={{ textTransform: 'none', letterSpacing: 0 }}
          >
            Get started
          </SolidButton>
        </form>
      }
    />
  );
};
